exports.install = function (Vue, options) {
    Vue.prototype.verifyPermissionData = function (data){
        this.$axios.get('/menu/verifyPermission',{
          params: {
            permission: data
          }
        })
        .then(response => {
          console.log('verifyPermissionData输入参数' + data)
          console.log('CommonJS接口返回数据')
          console.log(response)
          let code = response.code
          let message = response.msg
          if(code == '0'){
            //正常显示页面不做任何处理
            return
          }else if(code == '6'){
            //跳转到登录页
            if(localStorage.getItem('locale') =='zh'){
              this.$router.push({
                path: '/index'
              })
            }else if(localStorage.getItem('locale') =='en'){
              this.$router.push({
                path: '/loginEn/index'
              })
            }
            return
          }else{
            //跳转到个人账户总览页面
            this.$router.push({
              path: '/account/personaloverview'
            })
            return
          }
        })
        .catch(error => {
          console.log(error);
          this.abnormalSituation()
        });
    };
    Vue.prototype.abnormalSituation = function (data){
      let locale = localStorage.getItem('locale')
      if(locale == 'zh'){
        this.$router.push({
          name: "login"
        })
      }else if(locale == 'en'){
        this.$router.push({
          name: "loginEn"
        })
      }
    }
};
